/* global window */

import Vue from 'vue';
import { i18n } from '../../translation';

import './NewsletterSignup.scss';
import template from './NewsletterSignup.vhtml';

export default {
	name: 'NewsletterSignup',
	template: template,
	props: {
		iconLink: {
			type: String,
			default: '',
		},
		heading: {
			type: String,
			default: '',
		},
		callOut: {
			type: String,
			default: '',
		},
		isSingleRow: {
			type: Boolean,
			default: false,
		},
		isDoubleRow: {
			type: Boolean,
			default: false,
		},
		isBig: {
			type: Boolean,
			default: false,
		},
		isFooter: {
			type: Boolean,
			default: false,
		},
		hasAnimation: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		options: [
			{
				label: i18n.tc('business'),
				title: 'business_esbjerg',
			},
			{
				label: i18n.tc('entrepreneurship'),
				title: 'entrepreneur',
			},
			// {
			// 	label: i18n.tc('data_and_digitalization'),
			// 	title: 'data_and_digitalization',
			// },
			{
				label: i18n.tc('invest_in_esbjerg'),
				title: 'invest_in_esbjerg',
			},
		],
		selectedOptions: [],
		signupData: {
			honey: '',
			firstname: '',
			lastname: '',
			email: '',
			lists: [],
		},
	}),
	computed: {
		aosAnimation: (vm) => (vm.hasAnimation ? 'zoom-in' : ''),
		newsletterSignupClasses: (vm) => {
			let dynamicClasses = {
				'newsletter-signup--no-side-pad': vm.isFooter,
			};

			return ['newsletter-signup', dynamicClasses];
		},
		formClasses: (vm) => {
			let dynamicClasses = {
				'newsletter-signup__form--single-row': vm.isSingleRow,
				'newsletter-signup__form--double-row': vm.isDoubleRow,
			};

			return ['newsletter-signup__form', dynamicClasses];
		},
		iconClasses: (vm) => {
			let dynamicClasses = {
				'newsletter-signup__icon--big': vm.isBig,
			};

			return ['newsletter-signup__icon', dynamicClasses];
		},
		headingClasses: (vm) => {
			let dynamicClasses = {
				'newsletter-signup__heading--big': vm.isBig,
			};

			return ['newsletter-signup__heading', dynamicClasses];
		},
		btnClasses: (vm) => {
			let dynamicClasses = {
				'o-btn--stretch': !vm.isSingleRow && !vm.isDoubleRow,
				'o-btn--footer-newsletter': vm.isFooter,
			};

			return ['o-btn o-btn--big', dynamicClasses];
		},
		inputClasses: (vm) => {
			let dynamicClasses = {
				'input--big': vm.isBig,
			};

			return ['input', dynamicClasses];
		},
	},
	methods: {
		setupPlaceholder(str) {
			return `${str}...`;
		},
		formatLists(event) {
			if (Array.isArray(event)) {
				this.signupData.lists = event.map((item) => item.title);
			}
		},
		validateBeforeSubmit() {
			this.$validator.validateAll().then(() => {
				if (this.errors.items.length === 0) {
					this.submit(this.signupData);
				}
			});
		},
		submit() {
			if (this.signupData.honey === '') {
				/* this.$emit(
					'newsletter-signup-agreements',
					'newsletter-signup-agreements'
				);
				this.$emit('newsletter-signup-data', this.signupData); */
				window.siteData.popup = 'newsletter-signup-agreements';
				window.siteData.newsletterSignupData = this.signupData;
			}
		},
	},
};
